export default {"src":"/_next/static/media/hamburger.ab0cee1b.svg","height":20,"width":25};